<template>
  <div>
    <div class="nameSearch-Txt">
      <p>{{$t('i.search.name')}}</p>
      <div class="nameSearchLpt1">
        <input type="text" name="text" class="nameSearchLpt">
      </div>
      <input type="button" name="" class="nameSearchBtn" value="搜索" style="background: #fff url(../../../static/searchImg/search.png) no-repeat">
    </div>
    <div class="add">
      <input type="button" value="添加" @click="popupShow = true"
             style="background: #fff url(../../../static/searchImg/Add.png) no-repeat;">
    </div>
    <div class="operation">
      <p>{{$t('i.search.name')}}</p>
      <p>{{$t('i.search.operation')}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "nameSearch"
  }
</script>

<style scoped>
  .nameSearch-Txt{
    width: 915px;
    height: 45px;
    background-color: #f9fafc;
  }

  .nameSearch-Txt p{
    font-size: 30px;
    margin-left: 17px;
    float: left;
    line-height: 45px;
    display: inline;
  }

  .nameSearchLpt{
    width: 218px;
    height: 35px;
    border-radius: 5px;
    border: 1px solid #000;
    font-size: 20px;
  }

  .nameSearchBtn{
    width: 100px;
    height: 35px;
    border-radius: 5px;
    border: 1px solid #000;
    float: right;
    margin-top: 5px;
    margin-right: 35px;
    background-color: #fff;
    font-size: 22px;
    text-indent: 1em;
    cursor: pointer;
  }

  .nameSearchLpt1{
    float: left;
    margin-top: 5px;
    margin-left: 5px;
  }

  .add{
    width: 915px;
    height: 43px;
    margin-top: 7px;
  }

  .add input{
    width: 95px;
    height: 35px;
    color: #1182d8;
    border: 1px solid #1182d8;
    border-radius: 5px;
    background-color: #fff;
    text-indent: 1.2em;
    font-size: 22px;
    text-align: center;
    cursor: pointer;
  }
  .operation{
    width: 915px;
    height: 50px;
    background-color: #f9fafc;
    position: relative;
  }

  .operation p{
    display: inline;
    font-size: 22px;
    line-height: 50px;
  }

  .operation p:nth-child(1){
    position: absolute;
    left: 285px
  }

  .operation p:nth-child(2){
    position: absolute;
    left: 730px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/search/components/nameSearch.vue